module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// AnchorNavigator Widget

(function (fox, $) {
	"use strict";
	fox.registerWidget('AnchorNavigator', {

		init: function () {
			this.addDomHandler({
				event: 'click',
				target: this.requireOption('clickTarget'),
				targetWidget: this.requireOption('targetWidget'),
				callback: 'navigate'
			}, 'navigate');
		
			this.callParent('init', arguments);
		},

		navigate: function (el, evAlias, performer) {
			var id, $el, $target;

			$el = $(el);
			id = $el.data('target');
			$target = $(performer.dom1(['#', id].join('')));

			$el.parent()
				.find('.active')
				.removeClass('active');

			$el.addClass('active');

			if ($target) {
				$('body, html').animate({
					scrollTop: $(document).width() > 1194 ? $target.offset().top - 155 : $target.offset().top
				}, 500);
			}
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/area/model/common/widget/anchorNavigator.js
// module id = 54
// module chunks = 5